import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { v } from '../../styles/variables'
export const SCard = styled.div`
	position: relative;
	width: 100%;
	min-width: 270px;

	background: ${({ theme }) => theme.bgf};
	padding: ${v.mdSpacing};

	display: grid;
	box-shadow: 0 0 4px ${({ theme }) => theme.bg3}, 0 0 7px ${({ theme }) => theme.bg3};
	border: 1px solid ${({ theme }) => theme.bg3};
`

export const SLinkIcon = styled.div`
	padding: ${v.smSpacing} 0;
	position: absolute;
	bottom: 15px;
	display: flex;
	cursor: pointer;
	height: 17px;
	p {
		font-size: 10px;
	}
	svg {
		font-size: 15px;
	}
	&:hover {
		color: ${({ theme }) => theme.highlight};
	}
`
export const SCardLastUpdated = styled.span`
	color: inherit;
	position: absolute;
	bottom: 10px;
	right: 5px;
	font-size: 9px;
	text-align: center;
`
export const SLinkContainer = styled.div``

export const SCardTitle = styled.span`
	text-align: center;
	color: inherit;
	font-size: 28px;
`
export const SCardValue = styled.span`
	color: inherit;
	font-size: 24px;
	text-align: center;
	overflow-wrap: break-word;
`
export const SCardContent = styled.div`
	display: grid;
	width: 100%;
`
export const SLink = styled(Link)`
	text-decoration: none;
	color: inherit;
	font-size: 10px;
	&:hover {
		color: ${({ theme }) => theme.highlight};
	}
`
